import React from 'react';

import { KbjCardMeta, Piwik, SiteCoreDictionary } from '@eika-kortbetjening/types';
import { Button, ButtonTypes } from '@eika/button';

interface ReopenCardButtonProps {
    cardMeta: KbjCardMeta;
    reopenCardClick: (() => void) | undefined;
    dictionary: SiteCoreDictionary;
    isMobile: boolean;
    piwik: Piwik | undefined;
}

const ReopenCardButton = ({ cardMeta, reopenCardClick, dictionary, isMobile, piwik }: ReopenCardButtonProps) => {
    if (!cardMeta.state.isSoftblocked || typeof reopenCardClick === 'undefined') {
        return null;
    }

    return (
        <div className="card-control-panel__buttons-container">
            <Button
                data-track-id={piwik?.cardDetails?.linkReopenSelectedCard?.dataTrackId}
                data-track-linkname={piwik?.cardDetails?.linkReopenSelectedCard?.dataTrackLinkname}
                id={piwik?.cardDetails?.linkReopenSelectedCard?.dataTrackId}
                onClick={reopenCardClick}
                size="small"
                buttonType={isMobile ? ButtonTypes.SMALL_POSITIVE : ButtonTypes.STANDARD_POSITIVE}
            >
                {dictionary.blockSoftOpen}
            </Button>
        </div>
    );
};

export default ReopenCardButton;
